import { useEffect, useState } from "react";

export function useMaxHeight() {
  const [style, setStyle] = useState({});

  useEffect(() => {
    function updateStyle() {
      // Mobile (≤1023px) renders the userbar as a full-viewport drawer
      // (userbar.css media query). Skip the inline height so the CSS
      // `100dvh` rule wins — otherwise the drawer is cut off at the bottom
      // by `innerHeight - header - banner`. See foundation#4955.
      if (window.matchMedia("(max-width: 1023px)").matches) {
        setStyle({});
        return;
      }

      const root = document.documentElement;
      const headerLogoHeight = parseInt(
        getComputedStyle(root).getPropertyValue("--header-logo-height") || "0",
      );
      const navigationOffset = parseInt(
        getComputedStyle(root).getPropertyValue("--navigation-offset") || "60",
      );
      const headerTopbarHeight = parseInt(
        getComputedStyle(root).getPropertyValue("--header-topbar-height") ||
          "60",
      );
      // Banner-Höhe direkt vom DOM-Element lesen
      const bannerElement = document.querySelector(".header__banner");
      const bannerHeight = bannerElement
        ? bannerElement.getBoundingClientRect().height
        : 0;

      const bannerPosition = getComputedStyle(root)
        .getPropertyValue("--header-banner-position")
        .trim();

      const stickyTop = Math.max(headerLogoHeight, navigationOffset);

      // Berechne wie viel vom Banner noch sichtbar ist
      let visibleBannerHeight = 0;
      if (bannerPosition !== "fixed" && bannerHeight > 0) {
        visibleBannerHeight = Math.max(0, bannerHeight - window.scrollY);
      }

      // Die natürliche Position der Userbar ist nach Header + sichtbarem Banner
      // Aber mindestens bei stickyTop (wenn sticky greift)
      const naturalPosition = headerTopbarHeight + visibleBannerHeight;
      const userbarStartPosition = Math.max(stickyTop, naturalPosition);

      const height = window.innerHeight - userbarStartPosition;
      setStyle({ height: `${height}px` });
    }

    updateStyle();
    window.addEventListener("resize", updateStyle);
    window.addEventListener("scroll", updateStyle);
    return () => {
      window.removeEventListener("resize", updateStyle);
      window.removeEventListener("scroll", updateStyle);
    };
  }, []);

  return style;
}
